<template>
  <div>
    <div class="mb-4">
      <span class="caption">
        Number of terms:
      </span>
      <span
        class="caption font-weight-bold"
      >
        {{ filteredItems.length }} / {{ items.length }}
      </span>
    </div>
    <div class="mb-4">
      <v-chip
        class="mr-2 mb-2"
        label
        small
        outlined
        :color="!selectedType ? 'primary' : null"
        @click="selectedType = null"
      >
        All
      </v-chip>
      <v-chip
        class="mr-2 mb-2"
        label
        small
        outlined
        :color="selectedType === 'common' ? 'primary' : null"
        @click="selectedType = 'common'"
      >
        Common
      </v-chip>
      <v-chip
        class="mr-2 mb-2"
        label
        small
        outlined
        :color="selectedType === 'unique' ? 'primary' : null"
        @click="selectedType = 'unique'"
      >
        Unique
      </v-chip>
      <v-chip
        class="mr-2 mb-2"
        label
        small
        color="primary"
        @click="copy"
      >
        {{ copied ? 'Copied!' : 'Copy Terms' }}
      </v-chip>
    </div>
    <TopicList
      :items="filteredItems"
    />
  </div>
</template>

<script>
import TopicList from '../TopicList.vue'

export default {
    components: { TopicList },
    props: {
        items: {
            type: Array,
            default: () => []
        },
    },
    data: () => ({
        maxItems: 50,
        expand: false,
        selectedType: null,
        copied: false,
    }),
    computed: {
        filteredItems() {
            return this.items.filter(({ color, ...rest }) => {
                if (this.selectedType) {
                    if (this.selectedType === "common") {
                        return color === "green";
                    }
                    if (this.selectedType === "unique") {
                        return !color;
                    }
                }
                return true;
            });
        }
    },
    methods: {
        copy() {
            const content = this.filteredItems.map(({ topic }) => topic).join("\n");
            navigator.clipboard.writeText(content);
            this.copied = true;
            setTimeout(() => this.copied = false, 1000);
        }
    }
}
</script>
